import React from 'react';
import styled from '@emotion/styled';
import { sum, max } from 'd3-array';

import Timestamp from '~/scripts/components/Timestamp';
import CoronaNumbers from '~/scripts/components/CasesDisplay/CoronaNumbers';

const Wrapper = styled.div`
  padding: 10px 12px;
`;

const Header = styled.header`
  margin-bottom: 8px;
`;

const Title = styled.h3`
  margin: 0 0 4px;
  font-size: 16px;
  ${(p) => p.theme.breakpoints.sm.up} {
    font-size: 18px;
  }
`;

const TimestampWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Label = styled.div`
  color: ${(p) => p.theme.colors.lightText};
  font-size: 12px;
  ${(p) => p.theme.breakpoints.sm.down} {
    margin: 4px 0 2px;
  }
  ${(p) =>
    p.mobileOnly &&
    `
    ${p.theme.breakpoints.sm.up} {
      display: none;
    }
  `}
  ${(p) =>
    p.desktopOnly &&
    `
    ${p.theme.breakpoints.sm.down} {
      display: none;
    }
  `}
`;

const TwoColumns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.sm.up} {
    flex-direction: row;
  }
`;

const FirstColumn = styled.div`
  display: flex;
  ${(p) => p.theme.breakpoints.sm.up} {
    flex-grow: 3;
  }
`;

const SecondColumn = styled.div`
  display: flex;
  flex-grow: 1;
  margin-left: 1px;
`;

const CasesDisplay = ({ data, originalData, date }) => {
  const confirmed = sum(data, (d) => d.confirmed);
  const recovered = sum(data, (d) => d.recovered);
  const deaths = sum(data, (d) => d.deaths);
  const confirmedTotal = sum(originalData, (d) => d.confirmed);
  const recoveredTotal = sum(originalData, (d) => d.recovered);
  const deathsTotal = sum(originalData, (d) => d.deaths);

  const timestamp = !!date ? date : max(originalData, (d) => d.updated);

  return (
    <Wrapper>
      <Header>
        <Title>Coronavirus-Fälle in Deutschland</Title>
        <TimestampWrapper>
          <Timestamp timestamp={timestamp} />
          <Label desktopOnly>Fälle weltweit</Label>
        </TimestampWrapper>
      </Header>
      <TwoColumns>
        <FirstColumn>
          <CoronaNumbers confirmed={confirmed} recovered={recovered} deaths={deaths} />
        </FirstColumn>
        <Label mobileOnly>Fälle weltweit</Label>
        <SecondColumn>
          <CoronaNumbers
            confirmed={confirmedTotal}
            recovered={recoveredTotal}
            deaths={deathsTotal}
            smallNumbers
            showLabels={false}
          />
        </SecondColumn>
      </TwoColumns>
    </Wrapper>
  );
};

export default CasesDisplay;
